module.exports = __webpack_public_path__ + "f50a18b1c02ecc60a1a8ae5feb7de852.pdf";